interface SeriesItem {
  dataKey: string;
  label: string;
  stack: string;
  valueFormatter?: (val: any) => any;
}

const formatChartHoverNumber = (value: number | null | undefined): string => {
  const n = value == null ? 0 : Number(value);
  return (Number.isFinite(n) ? n : 0).toFixed(2);
};

export const valueFormatter = (value: number | null): string =>
  `${formatChartHoverNumber(value)} tCO2e`;

export const energyValueFormatter = (value: number | null): string =>
  `${formatChartHoverNumber(value)} kWh`;

export function buildGenericSeriesStack(dataset: any[], valueFormatter = (val: any) => val): SeriesItem[] {
  const keys: Set<string> = new Set();
  dataset.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (key !== "month" && key !== "displayIndex") {
        keys.add(key);
      }
    });
  });
  return Array.from(keys).map((key) => ({
    dataKey: key,
    label: key,
    stack: 'total',
    valueFormatter
  }));
}

export const SeriesBar = [
  { dataKey: 'totalEmission', label: 'Total Emissions', valueFormatter },
]

export const COMPARISON_EMISSION_KEY = 'comparisonEmission';

/** Two grouped (unstacked) bar series: the current period and the comparison period. */
export const getComparisonBarSeries = (currentLabel: string, comparisonLabel: string) => ([
  { dataKey: 'totalEmission', label: currentLabel, valueFormatter },
  { dataKey: COMPARISON_EMISSION_KEY, label: comparisonLabel, valueFormatter },
]);

export const getSeriesConfig = (dataKey1: string, label1: string, dataKey2: string, label2: string) => {
  const seriesConfig = [
    {
      dataKey: dataKey1,
      label: label1,
      valueFormatter,
      curve: 'linear',
      strokeWidth: 3,
    },
    {
      dataKey: dataKey2,
      label: label2,
      valueFormatter,
      curve: 'linear',
      strokeWidth: 3,
    }
  ];

  return seriesConfig;
}


export interface IDataSeries {
  dataKey: string;
  label: string;
  stack: string;
  valueFormatter: (value: number | null) => string;
}